// client/src/coms/voip/voiceclient_parts/state.js
export const VOICE_AUDIO_BITRATE_BPS = 32000;
// RED (redundant Opus frames) lets listeners recover lost packets; DTX keeps silence nearly free.
export const VOICE_AUDIO_RED = true;
export const PROXIMITY_POLL_MS = 250;
// Channels without map proximity only need to notice when it is switched on.
export const PROXIMITY_IDLE_POLL_MS = 5000;

export const SPEAKING_PACKET_TOPIC = 'pa-speaking';
export const SPEAKING_PACKET_TYPE = 'pa_speaking_v1';
export const SPEAKING_BROADCAST_MIN_MS = 90;
export const SPEAKING_REMOTE_STALE_MS = 900;

export const VOICE_STATUS_PACKET_TOPIC = 'pa-voice-status';
export const VOICE_STATUS_PACKET_TYPE = 'pa_voice_status_v1';
export const VOICE_STATUS_REMOTE_STALE_MS = 15000;

export const VOICE_ANIMATION_PACKET_TOPIC = 'pa-voice-animation';
export const VOICE_ANIMATION_PACKET_TYPE = 'pa_voice_animation_v1';
export const VOICE_ANIMATION_REMOTE_STALE_MS = 86400000;
export const DEFAULT_VOICE_ANIMATION = 'flash';

export const PROXIMITY_VOLUME_STOPS = [
  { distance: 1, volume: 1.0 },
  { distance: 2.5, volume: 0.2 },
  { distance: 5, volume: 0.08 },
  { distance: 10, volume: 0.01 },
  { distance: 15, volume: 0.005 },
  { distance: 20, volume: 0.003 },
  { distance: 25, volume: 0.0008 },
  { distance: 40, volume: 0.0 },
];

export const audioElsByTrackSid = new Map();
export const audioMetaByTrackSid = new Map();
export const remoteSpeakingStateByIdentity = new Map();
export const remoteVoiceStatusByIdentity = new Map();
export const remoteVoiceAnimationByIdentity = new Map();

export const voiceState = {
  pendingPlay: false,

  boundDeviceListener: false,
  activeRoom: null,
  activeComsRoomName: '',
  activeServerId: '',

  activeCaptureTrack: null,
  activeProcessedTrack: null,
  activeLocalPub: null,
  switchingMic: false,

  pttBound: false,
  pttHeld: false,
  pttTauriUnlisten: null,
  pttWindowEventBound: false,
  pttDocumentEventBound: false,

  sfxCtx: null,
  joinSfxLastAt: 0,
  leaveSfxLastAt: 0,

  gateCtx: null,
  gateAnalyser: null,
  gateSource: null,
  gateGain: null,
  gateDest: null,
  gateKeepAlive: null,
  gateTimer: null,
  gateBound: false,
  gateOpen: true,
  gateLastAboveAt: 0,
  gateLastApplyAt: 0,

  meterMonitorBound: false,
  meterMonitorOn: false,
  meterMonitorEl: null,
  meterMonitorStream: null,
  mutedRemoteVolumes: null,

  meterPrevPubMuted: null,
  meterSuppressed: false,

  activeCameraTrack: null,
  activeCameraPub: null,

  manualMicMuted: false,
  manualDeafened: false,

  participantPrefsBound: false,
  proximityBound: false,
  voiceAnimationBound: false,

  activeProximityState: null,
  proximityPollTimer: null,
  proximityPollInFlight: false,

  localSpeakingNow: false,
  localSpeakingLevel: 0,
  localSpeakingDb: -100,
  lastSpeakingBroadcastAt: 0,
  lastSpeakingBroadcastState: false,
  lastSpeakingBroadcastLevel: 0,

  localVoiceAnimation: DEFAULT_VOICE_ANIMATION,

  lastVideoErr: '',

  activeScreenStream: null,
  activeScreenTrack: null,
  activeScreenPub: null,
};